import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import './Services.css';

const services = [
  {
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences.',
    icon: '📱',
  },
  {
    title: 'Website Development',
    description: 'Modern, responsive websites built with cutting-edge technologies and best practices.',
    icon: '🌐',
  },
  {
    title: 'UI/UX Design',
    description: 'Intuitive and beautiful interfaces that engage users and drive conversions.',
    icon: '🎨',
  },
  {
    title: 'Custom Software',
    description: 'Tailored software solutions designed to meet your unique business requirements.',
    icon: '⚙️',
  },
  {
    title: 'Software Consulting',
    description: 'Expert guidance on technology strategy, architecture, and digital transformation.',
    icon: '💡',
  },
];

const ServiceCard = ({ service, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <motion.div
      ref={ref}
      className="service-card"
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      whileHover={{ scale: 1.05, y: -10 }}
    >
      <div className="service-icon">{service.icon}</div>
      <h3 className="service-title">{service.title}</h3>
      <p className="service-description">{service.description}</p>
    </motion.div>
  );
};

const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="services" className="services" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">My Services</h2>
          <p className="section-subtitle">
            Comprehensive solutions to transform your digital presence
          </p>
        </motion.div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

